import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import Sidebar from "../../component/sidebar";
import Header from "../../component/header";
import Controls from "../forms/controls/Controls";
import { useForm, Form } from "../forms/useForm";
import { useGetAboutPagesByIdQuery } from "../../../../services/aboutPageSlice";
import BlobToFile from "../forms/utils/blobToFile";
import { useUpdateAboutPageMutation } from "../../../../services/aboutPageSlice";
import urlToFile from "../forms/utils/urlToFile";
import { Box } from "@mui/system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faBell,
  faSignInAlt,
  faExclamationTriangle,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const AboutPageEditPage = () => {
  return (
    <Grid container className="dashboard-full-background">
      <Grid item xs={2} spacing={4}>
        <Sidebar />
      </Grid>
      <Grid item xs={10}>
        <Header />
        <EditAboutPagePages />
      </Grid>
    </Grid>
  );
};

const EditAboutPagePages = () => {
  const { id } = useParams();
  const AboutPages = useGetAboutPagesByIdQuery(id);
  const [File1, setFile1] = useState([]);
  const [File2, setFile2] = useState([]);
  const [SuccessMessege, setSuccesMessege] = useState(null);
  const [ErrorMessege, setErrorMessege] = useState(null);
  const [updateAboutPage, setUpdateAboutPage] = useState([]);
  const [initialFValues, setInitialFValues] = useState({
    image1: [],
    image2: [],
    title: "",
    subtitle: "",
    description: "",
    random1: "",
    random2: "",
    random3: "",
    is_active: "false",
  });
  const history = useNavigate();

  useEffect(() => {
    console.log(AboutPages.data);
    if (AboutPages.data) {
      if (AboutPages.data.image1) {
        urlToFile(AboutPages.data.image1, setFile1);
      }
      if (AboutPages.data.image2) {
        urlToFile(AboutPages.data.image2, setFile2);
      }

      setInitialFValues({
        image1: File1,
        image2: File2,
        title: AboutPages.data.title,
        subtitle: AboutPages.data.subtitle,
        description: AboutPages.data.description,
        random1: AboutPages.data.random1,
        random2: AboutPages.data.random2,
        random3: AboutPages.data.random3,
        is_active: AboutPages.data.is_active.toString(),
      });
    }
  }, [AboutPages.data]);

  const { values, handleImageUpload, handleInputChange } = useForm(
    initialFValues,
    true,
    false,
    true
  );

  const [editAboutPage] = useUpdateAboutPageMutation();

  useEffect(() => {
    handleImageUpload("image1", File1);
  }, [File1]);

  useEffect(() => {
    handleImageUpload("image2", File2);
  }, [File2]);

  console.log(values);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    var file1 = BlobToFile(values.image1, "aboutPage1");
    var file2 = BlobToFile(values.image2, "aboutPage2");
    var isTrueSet = values.is_active === "true";
    if (file1.length !== 0) {
      formData.append("image1", file1, "aboutPage1.jpg");
    }
    if (file2.length !== 0) {
      formData.append("image2", file2, "aboutPage2.jpg");
    }
    if(values.title)
      formData.append("title", values.title);
    if(values.subtitle)
      formData.append("subtitle", values.subtitle);
    if(values.description)
      formData.append("description", values.description);
    if(values.random1)
      formData.append("random1", values.random1);
    if(values.random2)
      formData.append("random2", values.random2);
    if(values.random3)
      formData.append("random3", values.random3);
    formData.append("is_active", isTrueSet);
    formData.append("id", id);
    editAboutPage(formData)
      .then((res) => {
        setSuccesMessege("Successfully Updated About Page Data.");
        setTimeout(() => {
          history("/dashboard/about-pages");
        }, [3000]);
      })
      .catch((err) => {
        setErrorMessege("Some Error Occur. Please Try Again Later.");
        setTimeout(() => {
          setErrorMessege(null);
        }, [3000]);
      });
  };

  return (
    <Box className="table-design-background">
      <Typography className="dashboard-home-page-text">
        Update About Page
      </Typography>
      <Box style={{ padding: "1.5rem" }}>
        <Form onSubmit={handleSubmit}>
          <Grid container>
            <Grid item xs={6}>
              <Controls.Input
                name="title"
                label="Title"
                value={values.title}
                onChange={handleInputChange}
              />
              <Controls.Input
                name="subtitle"
                label="Sub-Title"
                value={values.subtitle}
                onChange={handleInputChange}
              />
              <Controls.Input
                name="description"
                label="Description"
                value={values.description}
                onChange={handleInputChange}
              />
              <Controls.Input
                name="random1"
                label="Stats1"
                value={values.random1}
                onChange={handleInputChange}
              />
              <Controls.Input
                name="random2"
                label="Stats2"
                value={values.random2}
                onChange={handleInputChange}
              />
              <Controls.Input
                name="random3"
                label="Stats3"
                value={values.random3}
                onChange={handleInputChange}
              />
              <Controls.RadioGroup
                name="is_active"
                label="Is Active"
                value={values.is_active}
                onChange={handleInputChange}
                items={[
                  { id: "false", title: "False" },
                  { id: "true", title: "True" },
                ]}
              />
            </Grid>
            <Grid item xs={6}>
              <Box style={{ marginBottom: "12px" }}>
                <Controls.Image setFile={setFile1} aspectRatio={471 / 430} />
              </Box>
              <Controls.Image setFile={setFile2} aspectRatio={471 / 440} />
            </Grid>
            <Grid>
              <Controls.Button
                type="submit"
                text="Submit"
                backgroundColor="#1b284b"
                onClick={handleSubmit}
              />
            </Grid>
          </Grid>
        </Form>
        {SuccessMessege === null ? null : (
          <Box className="successmessege">
            <Typography className="messegefonts">
              <FontAwesomeIcon icon={faCheckCircle} className="messegeicon" />
              {SuccessMessege}
            </Typography>
          </Box>
        )}
        {ErrorMessege === null ? null : (
          <Box className="errormessege">
            <Typography className="messegefonts">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                className="messegeicon"
              />
              {ErrorMessege}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AboutPageEditPage;
